export const textStrings = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SIGN_OUT: "Sign Out",
  USER_PROFILE: "User Profile",
  NO_DATA_TO_DISPLAY: "No data to display",
  ACTIVE_BRANDS_FEEDBACK: "Active brands using Feedback",
  AI_REPLY: "AI Reply",
  AI_RESPONSE_DISCLAIMER:
    "AI responses can be inaccurate or misleading. Always review before publishing.",
  LEARN_MORE: "Learn more",
  JOIN_ACCOUNT: "Join Account",
  RESET_PASSWORD: "Reset Password",
  BACK_TO_LOGIN: "Back to Login",
  ERROR_BOUNDARY_MESSAGE:
    "Ooops! The action you would like to perform might have some issue please report so that we can fix it.",
};
